import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="newsComment";
export function selectByNewsId(newsId) {
  console.log("params:", newsId)
  return axios({
    url: `/ws/${moduleName}/selectByNewsId/${newsId}`,
    method: 'get',
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function deleteById(id){
  console.log("data:",id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'delete',
  })
}

export default {
  insert,
  selectByNewsId,
  deleteById,
}